import { render, staticRenderFns } from "./CellTemplate2digits.vue?vue&type=template&id=68dd9576&scoped=true&"
import script from "./CellTemplate2digits.vue?vue&type=script&lang=js&"
export * from "./CellTemplate2digits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dd9576",
  null
  
)

export default component.exports